import type { ReactNode } from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface SettingsCardProps {
  title: string
  description?: string
  actions?: ReactNode
  children: ReactNode
  className?: string
  headerClassName?: string
  titleClassName?: string
  descriptionClassName?: string
  contentClassName?: string
}

// Consistent panel chrome for every Settings sub-page (Figma card: rounded-2xl,
// bordered header row with title + actions, padded body).
export function SettingsCard({
  title,
  description,
  actions,
  children,
  className,
  headerClassName,
  titleClassName,
  descriptionClassName,
  contentClassName,
}: SettingsCardProps) {
  return (
    <Card
      className={cn(
        'overflow-hidden rounded-2xl border-[#d9d9d9] shadow-none',
        className
      )}
    >
      <CardHeader
        className={cn(
          'flex flex-row items-center justify-between gap-2 space-y-0 border-b border-[#d9d9d9] px-4 py-3',
          headerClassName
        )}
      >
        <div className='min-w-0 flex-1'>
          <CardTitle
            className={cn(
              'font-heading text-[20px] font-semibold leading-[1.2] tracking-normal',
              titleClassName
            )}
          >
            {title}
          </CardTitle>
          {description && (
            <CardDescription className={cn('mt-1', descriptionClassName)}>
              {description}
            </CardDescription>
          )}
        </div>
        <div className='shrink-0'>
          {actions ?? <div aria-hidden='true' className='h-10' />}
        </div>
      </CardHeader>
      <CardContent className={cn('p-6', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  )
}

export default SettingsCard
